var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fav_16x16",
    "data-name": "fav 16x16",
    transform: "translate(-435 -1571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 20,
    height: 20,
    transform: "translate(435 1571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(333.101 1399.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M333.609,179.4a1.1,1.1,0,0,0,1.09,1.252.992.992,0,0,0,1.04-.888.154.154,0,0,1,.161-.141h.7a.162.162,0,0,1,.171.161,1,1,0,0,1-.02.162,2.028,2.028,0,0,1-2.049,1.625,2.128,2.128,0,0,1-2.15-2.291v-.656a2.137,2.137,0,0,1,2.15-2.3A2.062,2.062,0,0,1,336.748,178a.322.322,0,0,1,.02.131.151.151,0,0,1-.151.162h-.7a.175.175,0,0,1-.172-.151,1.031,1.031,0,0,0-1.05-.888,1.1,1.1,0,0,0-1.09,1.252Z",
    transform: "translate(-220.383)",
    fill: "#6bcfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M104.959,179.4a1.1,1.1,0,0,0,1.09,1.252.992.992,0,0,0,1.04-.888.154.154,0,0,1,.161-.141h.7a.162.162,0,0,1,.172.161,1.013,1.013,0,0,1-.02.162,2.028,2.028,0,0,1-2.049,1.625,2.128,2.128,0,0,1-2.15-2.291v-.656a2.137,2.137,0,0,1,2.15-2.3A2.062,2.062,0,0,1,108.1,178a.322.322,0,0,1,.02.131.151.151,0,0,1-.151.162h-.7a.175.175,0,0,1-.172-.151,1.031,1.031,0,0,0-1.05-.888,1.1,1.1,0,0,0-1.09,1.252Z",
    fill: "#6bcfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(108.058 177.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M220.483,218.125a.282.282,0,0,1-.3-.275v-.46a.521.521,0,0,1,.221-.4l1.815-1.6c.416-.358.59-.55.59-.813,0-.348-.257-.548-.705-.548s-.729.2-.729.512a.3.3,0,0,1-.3.287h-.593a.288.288,0,0,1-.287-.287c0-.954.777-1.594,1.933-1.594,1.4,0,1.9.786,1.9,1.521a1.884,1.884,0,0,1-.826,1.486l-1.207,1.083H223.8a.045.045,0,0,1,.036.018l.619.445a.1.1,0,0,1,0,.157l-.625.449a.043.043,0,0,1-.03.013Z",
    transform: "translate(-220.139 -212.907)",
    fill: "#e0228b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M220.923,211.792c1.295,0,1.852.7,1.852,1.476a1.852,1.852,0,0,1-.811,1.452l-1.295,1.162h1.924l.628.451a.052.052,0,0,1,0,.084l-.628.451h-3.316a.236.236,0,0,1-.254-.23v-.46a.475.475,0,0,1,.206-.363l1.815-1.6c.436-.375.6-.569.6-.847,0-.339-.23-.593-.75-.593-.5,0-.775.23-.775.557a.253.253,0,0,1-.254.242h-.593a.243.243,0,0,1-.242-.242c0-.871.7-1.549,1.888-1.549m0-.09c-1.183,0-1.978.659-1.978,1.639a.333.333,0,0,0,.333.332h.593a.343.343,0,0,0,.345-.332c0-.288.262-.466.684-.466s.66.178.66.5c0,.242-.15.414-.574.778l-1.816,1.6a.56.56,0,0,0-.236.431v.46a.326.326,0,0,0,.344.32h3.316a.09.09,0,0,0,.065-.028l.616-.443a.142.142,0,0,0,0-.231l-.62-.446a.087.087,0,0,0-.061-.026H220.9l1.119-1a1.946,1.946,0,0,0,.841-1.52c0-.757-.51-1.567-1.942-1.567Z",
    transform: "translate(-218.933 -211.702)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.d019ad728f90423dbb10e981b69f33e8.svg";
export { ForwardRef as ReactComponent };